import { isPLTVEnabled, isUpsellGuidePlan } from './ltvCalculator';

const PLTV_DEFAULT_VALUE = 40.45;
const UPSELL_PLTV_DEFAULT_1MONTH = 16.66;
const UPSELL_PLTV_DEFAULT_3MONTHS = 11.28;

const resolveDefaultPLTV = (plan: string): number => {
  const name = plan.toLowerCase();
  if (!name.includes('upsell')) return PLTV_DEFAULT_VALUE;

  return name.includes('3month') ? UPSELL_PLTV_DEFAULT_3MONTHS : UPSELL_PLTV_DEFAULT_1MONTH;
};

type ResolveDynamicPLTVPriceParams = {
  landing?: string | null;
  plan: string;
  pltv: number | null | undefined;
};

export const resolveDynamicPLTVPriceForFlow = ({
  landing,
  plan,
  pltv,
}: ResolveDynamicPLTVPriceParams): number | undefined => {
  if (!isPLTVEnabled(landing) || isUpsellGuidePlan(plan)) {
    return undefined;
  }

  return typeof pltv === 'number' && Number.isFinite(pltv) ? pltv : resolveDefaultPLTV(plan);
};
